import { ISubscription } from '@leedpulse-monorepo/interfaces';
import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';
import { Authentication } from '@leedpulse-monorepo/classes';

export interface ResetMultipleDemoAccountsResponse {
  data: {
    message: string;
    successful: number;
    failed: number;
    total: number;
  };
  statusCode: number;
  statusReponse: string;
  success: boolean;
}

async function resetMultipleDemoAccounts(
  subscriptions: ISubscription["id"][],
  auth: Authentication | null,
  datasetFilename?: string,
): Promise<ResetMultipleDemoAccountsResponse> {
  try {
    if (!auth) throw new ResetDemoAccountFailure('Vous devez être connecté pour effectuer cette action.', 'unauthorized');

    const response = await HttpClient.post(
      `/backoffice/demoaccount/reset`,
      {
        subscription_ids: subscriptions,
        dataset_filename: datasetFilename,
      },
      auth.token,
    );

    return response;
  } catch (e) {
    if (e instanceof ResetDemoAccountFailure) throw e;
    // HttpClient throws plain Error; preserve message so the UI can show it
    const errMessage =
      e instanceof Error
        ? e.message
        : typeof e === 'string'
          ? e
          : 'Une erreur inattendue s’est produite.';
    throw new ResetDemoAccountFailure(
      errMessage.trim() || 'Erreur réseau ou serveur. Réessayez plus tard.',
      'request-failed',
    );
  }
}

export class ResetDemoAccountFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default resetMultipleDemoAccounts;
